import * as React from 'react';

import { SectionPrimaryComponentDynamicZone } from '@schema';

const IS_ANCHOR_LINK_REGEX = new RegExp(/#/);

export const redirectIfLinkHasAnchor = (url: string) => {
	if (IS_ANCHOR_LINK_REGEX.test(url)) {
		return `/#${url.split('#')[1]}`;
	}

	return url;
};

export const isNotSSR = typeof window !== 'undefined';

export type OptionalProps = Record<string, any>;

export const mapComponents = <P extends OptionalProps>(
	array: Array<any>,
	Component: any,
	optionalProps: OptionalProps = {},
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
) => (array || []).map((item, k) => <Component key={k} {...(item as P)} {...optionalProps} />);

export const branch = (
	test: boolean,
	left: React.ReactNode,
	right?: React.ReactNode,
	children?: JSX.Element | JSX.Element[],
): JSX.Element => {
	if (test) {
		return React.cloneElement(
			left as React.DetailedReactHTMLElement<any, HTMLElement>,
			null,
			children,
		);
	}

	if (!right) {
		return children as JSX.Element;
	}

	return React.cloneElement(
		right as React.DetailedReactHTMLElement<any, HTMLElement>,
		null,
		children,
	);
};

export const pickComponentPropertiesByKey = (
	components: Array<SectionPrimaryComponentDynamicZone>,
	key: string,
): any => {
	if (!key) {
		throw new Error('pickComponentPropertiesByKey: Missing key');
	}

	return components.find((c) => (c as any).__component === key);
};

export const highlightString = (text: string) => {
	const regex = /\*(.*?)\*/g;
	return text.replace(regex, '<span>$1</span>');
};

export enum TypeOfScheme {
	TECH = 'TECH',
	HOME = 'HOME',
	BIKE = 'BIKE',
	NURSERY = 'NURSERY',
}

export const getSchemeWebsite = (typeOfScheme: TypeOfScheme) => {
	switch (typeOfScheme) {
		case TypeOfScheme.NURSERY:
			return process.env.GATSBY_NURSERY_WEBSITE;
		case TypeOfScheme.TECH:
			return process.env.GATSBY_TECH_WEBSITE;
		case TypeOfScheme.HOME:
			return process.env.GATSBY_TECH_WEBSITE;
		default:
			return '';
	}
};

export enum PlanOptionType {
	MYSELF = 'MYSELF',
	TEAM = 'TEAM',
	LESS_THAN_FIFTY = 'LESS_THAN_FIFTY',
	MORE_THAN_FIFTY = 'MORE_THAN_FIFTY',
}

export enum PlanType {
	SELF_SERVE = 'SELF_SERVE',
	MANAGED = 'MANAGED',
}
